import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { WhatsAppIcon } from "./icons";
import { BRAND } from "../data/site";

export default function Footer() {
  const [zoom, setZoom] = useState(false);
  return (
    <footer data-testid="site-footer" className="noise-dark bg-navy-deep text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => setZoom(true)}
                data-testid="footer-brand-zoom-button"
                aria-label="Zoom the Manvi Travels logo"
                className="group cursor-zoom-in rounded-xl bg-white p-2.5 ring-1 ring-white/20 transition-transform duration-200 hover:scale-110"
              >
                <img
                  src="brand/manvi-logo.png"
                  alt="Manvi Travels logo"
                  className="h-28 w-auto object-contain transition-transform duration-200 group-hover:scale-[1.04]"
                />
              </button>
            </div>
            <p className="mt-4 text-sm italic text-white/70">
              {BRAND.tagline}
            </p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
              Tailor-made international holidays, planned by someone who has
              actually been there. Europe &amp; Japan specialists, based in
              Chembur, Mumbai.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-gold">
              Explore
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" data-testid="footer-link-home" className="text-white/70 transition-colors duration-200 hover:text-gold">Home</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="text-white/70 transition-colors duration-200 hover:text-gold">About Us</Link></li>
              <li><Link to="/destinations" data-testid="footer-link-destinations" className="text-white/70 transition-colors duration-200 hover:text-gold">Destinations</Link></li>
              <li><Link to="/our-trips" data-testid="footer-link-trips" className="text-white/70 transition-colors duration-200 hover:text-gold">Our Happy Clients</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="text-white/70 transition-colors duration-200 hover:text-gold">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-gold">
              Get in touch
            </h4>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
                <span>{BRAND.address}</span>
              </li>
              <li>
                <a href={BRAND.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors duration-200 hover:text-gold">
                  <Phone className="h-4 w-4 shrink-0 text-gold" />
                  {BRAND.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} data-testid="footer-email-link" className="flex items-center gap-3 break-all transition-colors duration-200 hover:text-gold">
                  <Mail className="h-4 w-4 shrink-0 text-gold" />
                  {BRAND.email}
                </a>
              </li>
            </ul>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Instagram"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white transition-colors duration-200 hover:border-gold hover:text-gold"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={BRAND.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                aria-label="WhatsApp"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white transition-colors duration-200 hover:border-gold hover:text-gold"
              >
                <WhatsAppIcon className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 text-center text-xs text-white/40">
          © {new Date().getFullYear()} Manvi Travels · www.manvitravels.in · All rights reserved
        </div>
      </div>

      {zoom && (
        <div
          data-testid="footer-brand-lightbox"
          className="fixed inset-0 z-[60] flex cursor-zoom-out items-center justify-center bg-black/80 p-6"
          onClick={() => setZoom(false)}
        >
          <div className="relative">
            <img
              src="brand/manvi-logo.png"
              alt="Manvi Travels logo enlarged"
              data-testid="footer-brand-lightbox-image"
              className="max-h-[85vh] w-auto max-w-[90vw] rounded-2xl bg-white p-4 shadow-2xl"
            />
            <p className="mt-3 text-center text-xs font-semibold uppercase tracking-[0.2em] text-white/70">
              Click anywhere to close
            </p>
          </div>
        </div>
      )}
    </footer>
  );
}
